const downloadBlobFile = async (
  blob: Blob,
  fileName: string
): Promise<void> => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};
export default downloadBlobFile;
